namespace SP.Data {
    export class RestockList {

        static async getRestockListInfo(id: number): Promise<RestockListInfo> {
            var response = await SP.get<any>("/api/v1/restock/get/" + id);
            if (response.status == 200) return response.data as RestockListInfo; 
            //else await SP.alertX(response.status + ": " + response.msg);
            return null;
        }

        static async getRestockListInfos(): Promise<RestockListInfo[]> {
            var response = await SP.get<any>("/api/v1/restock/list");
            if (response.status != 200) await SP.alertX(response.status + ": " + response.msg);
            return response.data as RestockListInfo[];
        }

      
    }
}